module.exports = __webpack_public_path__ + "1f482111d275ae4d3c655e5037240381.fbx";